module.exports = __webpack_public_path__ + "img/enrolled.4e50ae50.png";